import { useEffect, type ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import type { ParentCapability } from "./parentTypes";
import { useParentMode } from "./ParentModeContext";

export function PermissionRoute({
  capability,
  children,
}: {
  capability: ParentCapability;
  children: ReactNode;
}) {
  const { askParent, can } = useParentMode();
  const allowed = can(capability);
  useEffect(() => {
    if (!allowed) askParent();
  }, [allowed, askParent]);
  return allowed ? children : <Navigate replace to="/" />;
}

export function NewProjectPermissionRoute({ children }: { children: ReactNode }) {
  const location = useLocation();
  const capability: ParentCapability =
    new URLSearchParams(location.search).get("type") === "comic" ? "createComic" : "createDrawing";
  return <PermissionRoute capability={capability}>{children}</PermissionRoute>;
}
